
import { Component, Prop, Vue,Watch } from "vue-property-decorator";
import MatrixItemPicker from "./MatrixPrickerItem.vue";
import MatrixItemClass from "@/models/MatrixPicker/MatrixItemClass";
@Component({
  components: { MatrixItemPicker },
})
export default class Aterisk extends Vue {
  @Prop({ default: [] }) items: Array<MatrixItemClass>;
  @Prop({ default: 7 }) itemForRow: number;
  @Prop({default:1}) displayMode:number;
  @Prop({default:true}) showPagination: boolean; 

  currentRow: number = 1;
  currentValue: string = null;

  public itemSelected(value) {
    this.currentValue = value;
    this.$emit("itemSelected",value)
  }

  public isSelected(value) {
    return this.currentValue == value;
  }
  mounted() {
    console.log("items"); 
  }

  showRow() {}

  get canGoBackPagination(){
     
    return ( this.currentRow > 1  )
  }
  get canGoFowardsBackPagination(){
    return ( this.currentRow <  Math.ceil(this.items.length / this.itemForRow)   )
  }
  public goBack(){
    if(this.canGoBackPagination){
      this.currentRow --
    }
  }
  public goFowards(){
    if(this.canGoFowardsBackPagination){
      this.currentRow++
    }
  }
    @Watch("refresSelectedOutside")
   public  RefreshWatch(value){
    console.log("aa")
    console.log(value)

    }
}
